!function () {
  "use strict";

  if (customElements.get("pickup-availability")) return;

  var QUERY =
    "query PickupStock($handle: String!) { product(handle: $handle) { id variants(first: 100) { nodes { id quantityAvailable selectedOptions { name value } storeAvailability(first: 20) { nodes { quantityAvailable pickUpTime location { id name address { formatted phone } } } } } } } }";

  function escapeHtml(value) {
    var div = document.createElement("div");
    div.textContent = value == null ? "" : String(value);
    return div.innerHTML;
  }

  function formatAddress(address) {
    if (!address) return "";
    var formatted = address.formatted;
    if (Array.isArray(formatted)) return formatted.map(escapeHtml).join("<br>");
    return escapeHtml(formatted || "");
  }

  customElements.define(
    "pickup-availability",
    class extends HTMLElement {
      constructor() {
        super();
        var template = this.querySelector("template");
        this.errorHtml = template ? template.content.firstElementChild.cloneNode(true) : null;
        this.onClickRefreshList = this.onClickRefreshList.bind(this);

        var allowed = this.dataset.allowedLocations;
        try {
          this.allowedLocationIds = allowed ? JSON.parse(allowed) : [];
        } catch (e) {
          this.allowedLocationIds = [];
        }

        if (this.dataset.variantId) this.fetchAvailability(this.dataset.variantId);
      }

      fetchAvailability(variantId) {
        if (!variantId) return;
        var shopDomain = this.dataset.shopDomain;
        var token = this.dataset.storefrontToken;
        var handle = this.dataset.productHandle;
        var targetGid = "gid://shopify/ProductVariant/" + variantId;

        var self = this;
        fetch("https://" + shopDomain + "/api/2026-07/graphql.json", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Shopify-Storefront-Access-Token": token
          },
          body: JSON.stringify({ query: QUERY, variables: { handle: handle } })
        })
          .then(function (r) {
            return r.json().then(function (json) {
              return { status: r.status, ok: r.ok, json: json };
            });
          })
          .then(function (result) {
            if (!result.ok || result.json.errors) {
              console.error("pickup-stock: storefront request failed", result.status, result.json.errors || result.json);
              throw new Error("storefront_error");
            }
            var product = result.json && result.json.data && result.json.data.product;
            var variants = (product && product.variants && product.variants.nodes) || [];
            var node = variants.filter(function (v) {
              return v.id === targetGid;
            })[0];
            self.renderPreview(node || null);
          })
          .catch(function (err) {
            console.error("pickup-stock: fetch failed", err);
            self.renderError();
          });
      }

      onClickRefreshList() {
        this.fetchAvailability(this.dataset.variantId);
      }

      update(variant) {
        if (variant && variant.available) {
          this.dataset.variantId = variant.id;
          this.fetchAvailability(variant.id);
        } else {
          this.removeAttribute("available");
          this.innerHTML = "";
        }
      }

      renderError() {
        this.innerHTML = "";
        if (this.errorHtml) {
          this.appendChild(this.errorHtml);
          var btn = this.querySelector("button");
          if (btn) btn.addEventListener("click", this.onClickRefreshList);
        }
      }

      renderPreview(node) {
        var existingDrawer = document.querySelector("pickup-availability-drawer");
        if (existingDrawer) existingDrawer.remove();

        this._selectedOptions = (node && node.selectedOptions) || [];

        var allNodes = (node && node.storeAvailability && node.storeAvailability.nodes) || [];
        var allowed = this.allowedLocationIds;

        var eligible = allNodes.filter(function (n) {
          return !allowed.length || allowed.indexOf(n.location.id) !== -1;
        });

        var totalQty = (node && node.quantityAvailable) || 0;
        var pickupQty = eligible.reduce(function (sum, n) {
          return sum + (n.quantityAvailable || 0);
        }, 0);
        var warehouseQty = Math.max(0, totalQty - pickupQty);

        if (!eligible.length && warehouseQty <= 0) {
          this.innerHTML = "";
          this.removeAttribute("available");
          return;
        }

        var available = eligible.filter(function (n) {
          return n.quantityAvailable > 0;
        });
        var isOnlyWarehouse = available.length === 0 && warehouseQty > 0;
        var anyAvailable = available.length > 0 || isOnlyWarehouse;

        var iconCheck = this.dataset.iconCheck || "";
        var iconCancel = this.dataset.iconCancel || "";
        var iconLocation = this.dataset.iconLocation || "";
        var iconArrow = this.dataset.iconArrow || "";
        var labelHeading = this.dataset.labelPickupOptions || "";
        var labelViewStoreInfo = this.dataset.labelViewStoreInfo || "";

        var html =
          '<pickup-availability-preview class="pickup__preview ' +
          (anyAvailable ? "pickup__preview--available" : "pickup__preview--unavailable") +
          '">' +
          '<div class="pickup__preview__icon">' +
          (anyAvailable ? iconCheck : iconCancel) +
          "</div>" +
          '<div class="pickup__info">' +
          '<p class="pickup__preview__heading">' +
          iconLocation +
          labelHeading +
          "</p>";

        if (isOnlyWarehouse) {
          html +=
            '<p class="pickup__info__text">Disponible para envío a cualquier tienda</p>';
        } else if (anyAvailable) {
          var firstName = escapeHtml(available[0].location.name);
          var availableText = firstName;

          if (available.length > 1) {
            availableText += " · Ver más";
          }

          if (available.length > 1) {
            html +=
              '<details class="pickup__preview__details"><summary class="pickup__preview__summary"><span class="pickup__info__text">' +
              availableText +
              "</span>" +
              iconArrow +
              "</summary>";
            html += '<ul class="pickup__preview__list">';
            available.forEach(function (n) {
              html +=
                '<li class="pickup__preview__list__item is-available">' +
                iconCheck +
                escapeHtml(n.location.name) +
                "</li>";
            });
            html += "</ul></details>";
          } else {
            html += '<p class="pickup__info__text">' + availableText + "</p>";
          }

          html +=
            '<button id="ShowPickupAvailabilityDrawer" class="pickup__button text-link small" aria-haspopup="dialog" data-popup-open>' +
            labelViewStoreInfo +
            "</button>";
        } else {
          var closestName = escapeHtml(eligible[0].location.name);
          var unavailableText = (this.dataset.labelUnavailableAt || "").replace(
            "__LOCATION_NAME__",
            closestName
          );
          html += '<p class="pickup__info__text">' + unavailableText + "</p>";
        }

        html += "</div></pickup-availability-preview>";

        this.innerHTML = html;
        this.setAttribute("available", "");

        if (anyAvailable && !isOnlyWarehouse) {
          var drawerHtml = this.buildDrawer(available);
          document.body.insertAdjacentHTML("beforeend", drawerHtml);

          var drawerEl = document.querySelector("pickup-availability-drawer");
          var colorScheme = this.dataset.productPageColorScheme;
          if (drawerEl && colorScheme) {
            colorScheme.split(" ").forEach(function (c) {
              if (c) drawerEl.classList.add(c);
            });
          }

          var openBtn = this.querySelector("button[data-popup-open]");
          if (openBtn) {
            openBtn.addEventListener("click", function () {
              var popup = document.querySelector("pickup-availability-drawer popup-component");
              if (popup && popup.popupOpen) popup.popupOpen();
            });
          }
        }
      }

      buildDrawer(available) {
        var labelHeading = this.dataset.labelPickupOptions || "";
        var iconLocation = this.dataset.iconLocation || "";
        var iconCancel = this.dataset.iconCancel || "";
        var iconCheck = this.dataset.iconCheck || "";
        var closeLabel = this.dataset.closeLabel || "";
        var productTitle = this.dataset.productTitle || "";
        var hasOnlyDefault = this.dataset.hasOnlyDefaultVariant === "true";

        var badgesHtml = "";
        if (!hasOnlyDefault && this._selectedOptions && this._selectedOptions.length) {
          this._selectedOptions.forEach(function (opt) {
            badgesHtml +=
              '<span class="badge"><span class="text-light">' +
              escapeHtml(opt.name) +
              '</span><span class="divide">&nbsp;|&nbsp;</span>' +
              escapeHtml(opt.value) +
              "</span>";
          });
        }

        var itemsHtml = available
          .map(function (n) {
            return (
              '<li class="pickup__list__item">' +
              '<p class="strong">' +
              iconCheck +
              escapeHtml(n.location.name) +
              "</p>" +
              '<address class="pickup__address">' +
              formatAddress(n.location.address) +
              (n.location.address && n.location.address.phone
                ? '<br><a href="tel:' +
                  escapeHtml(n.location.address.phone) +
                  '">' +
                  escapeHtml(n.location.address.phone) +
                  "</a>"
                : "") +
              "</address></li>"
            );
          })
          .join("");

        return (
          "<pickup-availability-drawer>" +
          "<popup-component>" +
          '<dialog class="drawer" aria-modal="true" aria-labelledby="PickupAvailabilityHeading" data-pickup-drawer data-scroll-lock-required>' +
          '<form method="dialog"><button class="visually-hidden" aria-label="' +
          closeLabel +
          '"></button></form>' +
          '<div class="drawer__inner" data-scroll-lock-scrollable>' +
          '<div class="drawer__head">' +
          '<h3 class="drawer__heading" id="PickupAvailabilityHeading">' +
          iconLocation +
          labelHeading +
          "</h3>" +
          '<button type="button" class="drawer__close" data-popup-close aria-label="' +
          closeLabel +
          '">' +
          iconCancel +
          "</button>" +
          "</div>" +
          '<div class="drawer__body" data-pickup-drawer-body data-scroll-lock-scrollable>' +
          '<div class="pickup__product__wrap">' +
          '<p class="pickup__product__title">' +
          escapeHtml(productTitle) +
          "</p>" +
          (badgesHtml ? '<p class="pickup__variant">' + badgesHtml + "</p>" : "") +
          "</div>" +
          '<ul class="pickup__list" role="list" aria-label="' +
          labelHeading +
          '" data-store-availability-drawer-content tabindex="0">' +
          itemsHtml +
          "</ul>" +
          "</div></div></dialog></popup-component></pickup-availability-drawer>"
        );
      }
    }
  );
}();
